export default "__VITE_ASSET__BFJCnUtv__"